import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HrDashboardService } from '../../../services/hr-dashboard.service';

@Component({
  selector: 'app-user-detail',
  standalone: false,
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss'
})
export class UserDetailComponent {
 userDetail: any;
  userId!: number;

  constructor(
    private route: ActivatedRoute,
    private hrDashboardService: HrDashboardService, private location: Location
  ) {}

  ngOnInit(): void {
    this.userId = Number(this.route.snapshot.paramMap.get('userId'));
    this.loadUserDetails();
  }

  loadUserDetails(): void {
    this.hrDashboardService.getUserDetails(this.userId).subscribe({
      next: (data) => {
        this.userDetail = data;
      },
      error: (err) => console.error('Failed to load user details', err)
    });
  }

  goBack() {
  this.location.back(); // goes to the previous page (hierarchy)
}

}
